module.exports = __webpack_public_path__ + "static/media/post-01.76256aae.png";